<div class="wm-view wm-l-issuereporter-container webmate-default-theme">
  <div class="wm-topbar">
    <span class="wm-topbar-header">Manage Startup Scripts for Slot</span>
  </div>
  <div class="introduction-text">
    <p>
      After deployment, you can further customize the templates in this slot by adding PowerShell (Windows), AppleScript (MacOS) or Bash (MacOS and Linux) scripts that are executed once a template in this slot is deployed successfully.
    </p>
    <p>
      Note: The order of execution is not guaranteed. Make sure that there are no dependencies between scripts you upload!
    </p>
  </div>

  @if (!scripts || scripts.length === 0) {
    <div class="empty-list">
      No scripts available in this project
    </div>
  }
  @if (!!scripts && scripts.length > 0) {
    <div class="script-list-container">
      <div class="script-list">
        @for (s of scripts; track s) {
          <div class="script-entry">
            <div class="enabled-checkbox">
              <p-checkbox [binary]="true" [ngModel]="scriptEnabled(s)" (onChange)="toggleScript($event, s.asset)" [pTooltip]="scriptEnabled(s) ? 'Disable script for slot' : 'Enable script for slot'" tooltipZIndex="10000"></p-checkbox>
            </div>
            <div class="name">{{s.name}}</div>
            <div class="created">created {{s.created | wmCalendarFormat}}</div>
            <div class="delete"><fa-icon [icon]="'trash'" pTooltip="Remove script from project" tooltipZIndex="10000" (click)="deleteScript(s.asset)"></fa-icon></div>
            <div class="delete"><fa-icon [icon]="'download'" pTooltip="Download script" tooltipZIndex="10000" (click)="download(s)"></fa-icon></div>
          </div>
        }
      </div>
    </div>
  }

  @if (!uploading) {
    <div class="imageupload-dndarea" wmtDragDrop (filesDropped)="dropFiles($event)">
      <span class="imageupload-dnd-label small">Drop scripts ({{getTypeString()}}) here</span>
      <span class="imageupload-dnd-label small">or</span>
      <div class="imageupload-chooser">
        <input hidden type="file" class="imageupload-filechooser" #fileInput id="fileInput" [accept]="validTypes.join(',')" (change)="selectFiles($event)" multiple>
        <p-button class="p-button-secondary" (click)="openFileChooser()">Choose</p-button>
      </div>
    </div>
  }
  @if (uploading) {
    <div class="upload-spinner">
      <p-progressSpinner></p-progressSpinner>
      <span>Uploading...</span>
    </div>
  }
</div>
